<template lang="pug">
.d-flex.jc-center.ai-center.fd-column.pa-4
  v-progress-circular(:size='45' :width='4' color='primary' indeterminate='')
  span.mt-4.font-weight-700 Estamos activando tu cuenta
</template>
<script>
import Router from '../router/not_logged.js'
import { apiPost, notify } from '../util/general'
export default {
  data () {
    return {
      isLoading: true,
      token    : localStorage.getItem('token')
    }
  },
  created () {
    var vm = this
    vm.fetchActivateEmail()
  },
  methods : {
    fetchActivateEmail () {
      var vm = this
      var obj = {
        email      : vm.$route.query.email,
        tokenVerify: vm.$route.query.verify
      }

      apiPost(vm, '/usuario/verificar/email', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Tu cuenta fue activada correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.goTo('/')
      })
    },
    goTo (page) {
      var vm = this
      Router.push(page)
      vm.token && vm.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Verificar_email.vue?42ee5784